<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import ContactDetailsItem from './ContactDetailsItem.vue';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown.vue';

export default {
  components: {
    ContactDetailsItem,
    MultiselectDropdown,
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      bots: 'agentBots/getBots',
    }),
    assignedBot() {
      return this.currentChat?.meta?.assignee_agent_bot || null;
    },
    botOptions() {
      const none = {
        id: 0,
        name: this.$t('CONVERSATION_SIDEBAR.AGENT_BOT_NONE'),
      };
      return this.assignedBot ? [none, ...this.bots] : this.bots;
    },
    hasAccessibleBots() {
      return Array.isArray(this.bots) && this.bots.length > 0;
    },
  },
  mounted() {
    if (!this.bots || this.bots.length === 0) {
      this.$store.dispatch('agentBots/get');
    }
  },
  methods: {
    onSelect(selected) {
      if (!selected) return;
      const conversationId = this.currentChat.id;
      const isNoneOrSame =
        selected.id === 0 ||
        (this.assignedBot && this.assignedBot.id === selected.id);
      const agentBotId = isNoneOrSame ? null : selected.id;
      const optimistic = isNoneOrSame ? null : selected;

      this.$store.dispatch('setCurrentChatAssigneeAgentBot', {
        conversationId,
        agentBot: optimistic,
      });
      this.$store
        .dispatch('assignAgentBot', { conversationId, agentBotId })
        .then(() => {
          useAlert(this.$t('CONVERSATION_SIDEBAR.AGENT_BOT_CHANGED'));
        });
    },
  },
};
</script>

<template>
  <div>
    <template v-if="hasAccessibleBots">
      <ContactDetailsItem
        compact
        :title="$t('CONVERSATION_SIDEBAR.AGENT_BOT_LABEL')"
      />
      <MultiselectDropdown
        :options="botOptions"
        :selected-item="assignedBot"
        :multiselector-title="$t('CONVERSATION_SIDEBAR.AGENT_BOT_LABEL')"
        :multiselector-placeholder="
          $t('CONVERSATION_SIDEBAR.AGENT_BOT_PLACEHOLDER')
        "
        :no-search-result="$t('CONVERSATION_SIDEBAR.AGENT_BOT_NO_RESULTS')"
        :input-placeholder="
          $t('CONVERSATION_SIDEBAR.AGENT_BOT_INPUT_PLACEHOLDER')
        "
        @select="onSelect"
      />
    </template>
  </div>
</template>
